
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default{
components:{
Cell,
XButton
},
data(){
return {
jsPassanger:'',
noMsg:"请登录后设置联系人",
cdqcp_conn:""
}
},
props:["urlFlag"],
watch:{
jsPassanger:function(newValue,oldValue){

}
},
methods:{
yz(val){
return this.$until.yzFontColor(val);
},
choose(){



localStorage.setItem("loginkey","14");

let openId = this.$until.getUrlParam("openId");
let cdqcpOpenId = localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid");
if((this.$until.getUrlParam("from")&&(!openId || openId ==='null'))||(localStorage.getItem("appFrom") && (!cdqcpOpenId || cdqcpOpenId == 'null'))){
localStorage.setItem("noTime",1);
var newHref =  location.href.indexOf('?') != -1?location.href.substr(0,location.href.indexOf('?')):location.href;
var Href_last = newHref.indexOf("pickupStation") != -1?"pickupStation":"giveawayStation";
var  href_origin =   newHref.substr("0", newHref.indexOf("#"));
location.href = '/user/passenger?type=conn&tzType=new&tzBuss=shuttle&choose=true&edit=false&delete=false&te=4&backUrl=' + encodeURIComponent(href_origin+Href_last)+"&connName=1##needLogIn=1"
return;
}
if(this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null' && this.$until.getUrlParam("openId")){
window.localStorage.setItem("cdqcp_opid",this.$until.getUrlParam("openId"));
window.localStorage.setItem("useCar_cdqcp_opid",this.$until.getUrlParam("openId"))
};

window.localStorage.setItem("personLabel","1");

if ((!window.localStorage.getItem("cdqcp_opid") || !window.localStorage.getItem("useCar_cdqcp_opid"))){
var newHref =  location.href.indexOf('?') != -1?location.href.substr(0,location.href.indexOf('?')):location.href;
setTimeout(function(){

location.href = '/user/login?backurl=' + encodeURIComponent(newHref+"?noTime=1");
},10)
return;
}

var newHref =  location.href.indexOf('?') != -1?location.href.substr(0,location.href.indexOf('?')):location.href;
var Href_last = newHref.indexOf("pickupStation") != -1?"pickupStation":"giveawayStation";
var  href_origin =   newHref.substr("0", newHref.indexOf("#"));
location.href = '/user/passenger?type=conn&tzType=new&tzBuss=shuttle&choose=true&edit=false&delete=false&te=4&backUrl=' + encodeURIComponent(href_origin+Href_last)+"&connName=1"
},
rphone(v){

return v.substr(0,3) + '****' + v.substr(7,11);
},
cdqcp_connc(a,b){


if (!a && !b){
if (!this.cdqcp_conn.realName || !this.cdqcp_conn.phone){
this.noMsg = "请选择联系人";

}
} else {

if (!a || !b){
this.noMsg = "请选择联系人";

}
}
let ccc = a;
this.jsPassanger =(!a||!b)?"":(ccc.length > 4 ? ccc.substr(0,4) : ccc) + ' ' + (b || this.rphone(this.cdqcp_conn.phone))
console.log("jsPassanger", this.jsPassanger);
setTimeout(()=>{
this.$emit('input',this.jsPassanger);
})

},
appLogin(newOpenId){

this.$http.post(window.innerAPI + '?server=tz_getUserInfo',{
userToken:newOpenId,
_p_from:(this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null')||localStorage.getItem("appFrom")||localStorage.getItem("cdqcp_channel") || localStorage.getItem("useCar_cdqcp_channel")
}).then((res) =>{

if(res.data.data.pubResponse.code =="0000"){
var data =  res.data.data.body;
localStorage.setItem("userMessage",JSON.stringify(
{
state:"1",
data: {
accessHeadUrl: data.headImg,
birthday: data.birthday,
cServicePhoneTime: "",
email: data.email,
gender: data.gender,
idNumber: data.idCard,
idType: data.idType,
msgLastPublishTime: "",
phone: data.phone,
realName: data.name,
userName: data.username
}
}
));
localStorage.setItem("cdqcp_opid", newOpenId);
localStorage.setItem("useCar_cdqcp_opid", newOpenId);

this.mapLogin();
}
})

},
mapLogin(){
let cdqcpConn = localStorage.getItem("cdqcp_conn") || localStorage.getItem("useCar_cdqcp_conns");
if (cdqcpConn&&!this.$until.getUrlParam("from")){
let realName = JSON.parse(cdqcpConn).realName || JSON.parse(cdqcpConn).userName;
let phone = JSON.parse(cdqcpConn).phone;
this.cdqcp_connc(realName,phone);
} else if (localStorage.getItem("userMessage")){


let realName = JSON.parse(localStorage.getItem("userMessage")).data.realName;
let phone = JSON.parse(localStorage.getItem("userMessage")).data.phone;
this.cdqcp_connc(realName,phone);
}else if(!localStorage.getItem("userMessage")&&!cdqcpConn ){
this.appLogin(localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"))
}
},
},
mounted(){
var appFlag = this.$until.getUrlParam('from') || localStorage.getItem("appFrom");
var newOpenId = this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid");

if(appFlag&& newOpenId){
if(!this.$until.getUrlParam('from')&&localStorage.getItem("userMessage") && newOpenId == (localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"))){
this.mapLogin();

}else{
this.appLogin(newOpenId);

}
}
if(this.$until.getUrlParam('from')){
localStorage.setItem("appFrom", appFlag);
}
/*if(this.$until.getUrlParam('from') && !this.$until.getUrlParam('openId') && !localStorage.getItem("cdqcp_opid")) {
localStorage.removeItem("cdqcp_opid");
localStorage.removeItem("userMessage");
}*/
if(!appFlag){
this.mapLogin();
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/choosePerson.vue